import BreadCrumbsSection from "../components/single-blog-light/breadcrumbs-section";
import SingleBlogContainer from "../components/single-blog-light/single-blog-container";

export default function SingleBlog() {
	return (
		<>
			<BreadCrumbsSection />
			<SingleBlogContainer />
		</>
	);
}
